module.exports = __webpack_public_path__ + "static/24-58dd1d0fd898cf7d44a05a681d9cb0be.jpg";